// import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// // Create axios instance
// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Add token to requests automatically
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Handle response errors
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401 || error.response?.status === 403) {
//       // Check if it's a "needs enrollment" error
//       if (error.response?.data?.needsEnrollment) {
//         // Don't redirect to login, just return the error
//         return Promise.reject(error);
//       }
      
//       // Token expired or invalid - redirect to login
//       if (error.response?.data?.needsLogin) {
//         localStorage.removeItem('token');
//         window.location.href = '/login';
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// // ========== AUTH API ==========
// export const authAPI = {
//   googleLogin: () => {
//     window.location.href = `${API_BASE_URL}/auth/google`;
//   },
//   getCurrentUser: () => api.get('/auth/me'),
//   verifyToken: () => api.get('/auth/verify'),
//   logout: () => api.post('/auth/logout'),
// };

// // ========== PREMIUM BATCH API ==========
// export const batchAPI = {
//   // Public routes
//   getAllBatches: () => api.get('/fetch-premium-batches'),
//   getBatchDetails: (batchId) => api.get(`/get-premium-batch/${batchId}`),
//   checkBatchAccess: (batchId) => api.get(`/check-batch-access/${batchId}`),
  
//   // Admin only routes
//   createBatch: (formData) => api.post('/create-premium-batch', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   updateBatch: (batchId, data) => api.put(`/update-premium-batch/${batchId}`, data),
//   deleteBatch: (batchId) => api.delete(`/delete-premium-batch/${batchId}`),
  
//   // Enrollment management (Admin only)
//   enrollUser: (batchId, email) => api.post('/enroll-user', { batchId, email }),
//   removeUser: (batchId, userId) => api.post('/remove-user', { batchId, userId }),
//   getEnrolledUsers: (batchId) => api.get(`/enrolled-users/${batchId}`),
// };

// // ========== PREMIUM QUIZ API ==========
// export const premiumQuizAPI = {
//   // Protected routes - requires enrollment
//   getBatchQuizzes: (batchId, page = 1, limit = 15) => 
//     api.get(`/get-premium-quizes/${batchId}?page=${page}&limit=${limit}`),
//   getQuiz: (batchId, quizId) => api.get(`/get-premium-quiz/${batchId}/${quizId}`),
//   submitQuiz: (data) => api.post('/submit-premium-quiz', data),
//   getUserAttempts: (userId, batchId) => api.get(`/user-batch-attempts/${userId}/${batchId}`),
  
//   // Admin only routes
//   createQuiz: (data) => api.post('/create-premium-quiz', data),
//   deleteQuiz: (quizId) => api.delete(`/delete-premium-quiz/${quizId}`),
// };

// // ========== REGULAR QUIZ API ==========
// export const quizAPI = {
//   // Public routes
//   getAllQuizzes: (page = 1, limit = 15) => 
//     api.get(`/getallquizes?page=${page}&limit=${limit}`),
//   getQuiz: (quizId) => api.get(`/getquiz/${quizId}`),
  
//   // Authenticated routes
//   submitQuiz: (data) => api.post('/submitquiz', data),
  
//   // Admin only routes
//   createQuiz: (data) => api.post('/createquiz', data),
//   updateQuiz: (quizId, data) => api.put(`/updatequiz/${quizId}`, data),
//   deleteQuiz: (quizId) => api.delete(`/deletequiz/${quizId}`),
// };

// // ========== ARTICLES API ==========
// export const articlesAPI = {
//   getAllArticles: () => api.get('/articles'),
//   getArticle: (articleId) => api.get(`/article/${articleId}`),
  
//   // Admin only
//   createArticle: (data) => api.post('/createarticle', data),
//   updateArticle: (articleId, data) => api.put(`/updatearticle/${articleId}`, data),
//   deleteArticle: (articleId) => api.delete(`/deletearticle/${articleId}`),
// };

// // ========== LATEST UPDATES API ==========
// export const updatesAPI = {
//   getAllUpdates: () => api.get('/getallupdates'),
//   getUpdate: (updateId) => api.get(`/getupdate/${updateId}`),
  
//   // Admin only
//   createUpdate: (data) => api.post('/uploadlinks', data),
//   deleteUpdate: (updateId) => api.delete(`/deleteupdate/${updateId}`),
// };

// // ========== STUDY MATERIAL API ==========
// export const studyMaterialAPI = {
//   getAllMaterials: () => api.get('/study-materials'),
//   getMaterial: (materialId) => api.get(`/study-material/${materialId}`),
  
//   // Admin only
//   uploadMaterial: (formData) => api.post('/uploadcontent', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   deleteMaterial: (materialId) => api.delete(`/deletematerial/${materialId}`),
// };

// // ========== PROTECTED API (General) ==========
// export const protectedAPI = {
//   getProtectedData: () => api.get('/protected'),
// };

// // ========== DASHBOARD API ==========
// export const dashboardAPI = {
//   getUserStats: (userId) => api.get(`/user-stats/${userId}`),
//   getRecentActivity: (userId) => api.get(`/recent-activity/${userId}`),
// };

// export default api;


import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Your backend uses both formats:
      config.headers.Authorization = `Bearer ${token}`; // For adminAuth
      config.headers.token = token; // For checkBatchAccess
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Check if it's a "needs enrollment" error
      if (error.response?.data?.needsEnrollment) {
        // Don't redirect to login, just return the error
        return Promise.reject(error);
      }
      
      // Check if it's an admin access error
      if (error.response?.data?.message?.includes('Admin access required')) {
        // Don't redirect, just show error
        return Promise.reject(error);
      }
      
      // Token expired or invalid - redirect to login
      if (error.response?.data?.needsLogin || 
          error.response?.data?.message?.includes('login again')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ========== AUTH API ==========
export const authAPI = {
  googleLogin: () => {
    window.location.href = `${API_BASE_URL}/auth/google`;
  },
  getCurrentUser: () => api.get('/auth/me'),
  verifyToken: () => api.get('/auth/verify'),
  logout: () => api.post('/auth/logout'),
};

// ========== PREMIUM BATCH API ==========
export const batchAPI = {
  // Public routes
  getAllBatches: () => api.get('/fetch-premium-batches'),
  getBatchDetails: (batchId) => api.get(`/get-premium-batch/${batchId}`),
  checkBatchAccess: (batchId) => api.get(`/check-batch-access/${batchId}`),
  
  // Admin only routes (requires user.role === 'admin')
  createBatch: (formData) => api.post('/create-premium-batch', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updateBatch: (batchId, data) => api.put(`/update-premium-batch/${batchId}`, data),
  deleteBatch: (batchId) => api.delete(`/delete-premium-batch/${batchId}`),
  
  // Enrollment management (Admin only)
  enrollUser: (batchId, email) => api.post('/enroll-user', { batchId, email }),
  removeUser: (batchId, userId) => api.post('/remove-user', { batchId, userId }),
  getEnrolledUsers: (batchId) => api.get(`/enrolled-users/${batchId}`),
};

// ========== PREMIUM QUIZ API ==========
export const premiumQuizAPI = {
  // Protected routes - requires enrollment
  getBatchQuizzes: (batchId, page = 1, limit = 15) => 
    api.get(`/get-premium-quizes/${batchId}?page=${page}&limit=${limit}`),
  
  getQuiz: (batchId, quizId) => api.get(`/get-premium-quiz/${batchId}/${quizId}`),
  
  submitQuiz: (data) => api.post('/submit-premium-quiz', data),
  
  getUserAttempts: (userId, batchId) => api.get(`/user-batch-attempts/${userId}/${batchId}`),
  
  // Admin only routes
  createQuiz: (data) => api.post('/create-premium-quiz', data),
  deleteQuiz: (quizId) => api.delete(`/delete-premium-quiz/${quizId}`),
};

// ========== RANKING API ==========
export const rankingAPI = {
  // ========== PUBLIC ROUTES (Within Batch - Requires Enrollment) ==========
  
  /**
   * Get paginated rankings for a batch
   * @param {string} batchId - Batch ID
   * @param {number} page - Page number (default: 1)
   * @param {number} limit - Items per page (default: 50)
   * @returns {Promise} Rankings data with pagination
   */
  getBatchRankings: (batchId, page = 1, limit = 50) => 
    api.get(`/rankings/batch/${batchId}?page=${page}&limit=${limit}`),
    // Get batch leaderboard with pagination


  /**
   * Get top N rankers in a batch
   * @param {string} batchId - Batch ID
   * @param {number} limit - Number of top rankers (default: 10)
   * @returns {Promise} Top rankers list
   */
  getTopRankers: (batchId, limit = 10) => 
    api.get(`/rankings/batch/${batchId}/top?limit=${limit}`),
  
  // ========== USER ROUTES (Own Data Only - Requires Enrollment) ==========
  
  /**
   * Get current user's rank in a batch
   * User ID is extracted from token on backend
   * @param {string} batchId - Batch ID
   * @returns {Promise} User's rank and stats
   */
  getMyRank: (batchId) => 
    api.get(`/rankings/batch/${batchId}/my-rank`),
  
  /**
   * Get current user's detailed performance in a batch
   * Includes quiz-wise breakdown
   * @param {string} batchId - Batch ID
   * @returns {Promise} User's performance details
   */
  getMyPerformance: (batchId) => 
    api.get(`/rankings/batch/${batchId}/my-performance`),
  
  /**
   * Get rankings around current user
   * Shows users ranked above and below
   * @param {string} batchId - Batch ID
   * @param {number} range - Number of ranks above and below (default: 5)
   * @returns {Promise} Rankings context around user
   */
  getMyRankingsContext: (batchId, range = 5) => 
    api.get(`/rankings/batch/${batchId}/my-context?range=${range}`),
  
  // ========== ADMIN ROUTES (Requires user.role === 'admin') ==========
  
  /**
   * Get specific user's rank (Admin only)
   * @param {string} batchId - Batch ID
   * @param {string} userId - User ID
   * @returns {Promise} User's rank and stats
   */
  getUserRank: (batchId, userId) => 
    api.get(`/rankings/batch/${batchId}/user/${userId}/rank`),
  
  /**
   * Get specific user's performance (Admin only)
   * @param {string} batchId - Batch ID
   * @param {string} userId - User ID
   * @returns {Promise} User's performance details
   */
  getUserPerformance: (batchId, userId) => 
    api.get(`/rankings/batch/${batchId}/user/${userId}/performance`),
  
  /**
   * Rebuild batch rankings (Admin only)
   * Recalculates all rankings from scratch
   * @param {string} batchId - Batch ID
   * @param {object} options - Optional: { force: boolean, notify: boolean, dryRun: boolean }
   * @returns {Promise} Rebuild result
   */
  rebuildBatchRankings: (batchId, options = {}) => 
    api.post(`/rankings/batch/${batchId}/rebuild`, options),
  
  /**
   * Get batch statistics (Admin only)
   * Includes average score, top scorer, etc.
   * @param {string} batchId - Batch ID
   * @returns {Promise} Batch statistics
   */
  getBatchStats: (batchId) => 
    api.get(`/rankings/batch/${batchId}/stats`),
};


// ========== REGULAR QUIZ API ==========
export const quizAPI = {
  // // Public routes
  // getAllQuizzes: (page = 1, limit = 15) => 
  //   api.get(`/getallquizes?page=${page}&limit=${limit}`),
  // Get all quizzes with pagination
  getAllQuizzes: (page = 1, limit = 15) =>
    api.get(`/getallquizes?page=${page}&limit=${limit}`),

  // ✅ NEW: Get quizzes by subject
  getQuizzesBySubject: (subject, page = 1, limit = 15) =>
    api.get(`/getallquizes?subject=${encodeURIComponent(subject)}&page=${page}&limit=${limit}`),
  
  getQuiz: (quizId) => api.get(`/getquiz/${quizId}`),
  
  // Authenticated routes
  submitQuiz: (data) => api.post('/submitquiz', data),
  
  // Admin only routes
  createQuiz: (data) => api.post('/createquiz', data),
  updateQuiz: (quizId, data) => api.put(`/updatequiz/${quizId}`, data),
  deleteQuiz: (quizId) => api.delete(`/deletequiz/${quizId}`),
};

// ========== ARTICLES API ==========
export const articlesAPI = {
  getAllArticles: () => api.get('/articles'),
  getArticle: (articleId) => api.get(`/article/${articleId}`),
  
  // Admin only
  createArticle: (data) => api.post('/createarticle', data),
  updateArticle: (articleId, data) => api.put(`/updatearticle/${articleId}`, data),
  deleteArticle: (articleId) => api.delete(`/deletearticle/${articleId}`),
};

// ========== LATEST UPDATES API ==========
export const updatesAPI = {
  getAllUpdates: () => api.get('/getallupdates'),
  getUpdate: (updateId) => api.get(`/getupdate/${updateId}`),
  
  // Admin only
  createUpdate: (data) => api.post('/uploadlinks', data),
  deleteUpdate: (updateId) => api.delete(`/deleteupdate/${updateId}`),
};

// ========== STUDY MATERIAL API ==========
export const studyMaterialAPI = {
  getAllMaterials: () => api.get('/study-materials'),
  getMaterial: (materialId) => api.get(`/study-material/${materialId}`),
  
  // Admin only
  uploadMaterial: (formData) => api.post('/uploadcontent', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteMaterial: (materialId) => api.delete(`/deletematerial/${materialId}`),
};

// ========== PROTECTED API (General) ==========
export const protectedAPI = {
  getProtectedData: () => api.get('/protected'),
};

// ========== DASHBOARD API ==========
export const dashboardAPI = {
  getUserStats: (userId) => api.get(`/user-stats/${userId}`),
  getRecentActivity: (userId) => api.get(`/recent-activity/${userId}`),
};


// ========== TYPING PRACTICE API ==========
export const typingAPI = {
  // ── User routes ──────────────────────────────────────────────
  // Get paragraphs (filtered by language/difficulty/topic)
  // Returns only what user has access to (free or free+premium)
  getParagraphs: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return api.get(`/typing/paragraphs${query ? `?${query}` : ''}`);
  },

  // Get a single paragraph by ID (access-checked on backend)
  getParagraphById: (id) => api.get(`/typing/paragraphs/${id}`),

  // Get available topics (for filter dropdown)
  getTopics: (language) =>
    api.get(`/typing/topics${language ? `?language=${language}` : ''}`),

  // Get current user's subscription status
  getMySubscription: () => api.get('/typing/my-subscription'),

  // ── Admin routes ─────────────────────────────────────────────
  adminGetAllParagraphs: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return api.get(`/typing/admin/paragraphs${query ? `?${query}` : ''}`);
  },

  createParagraph: (data) => api.post('/typing/paragraphs', data),

  updateParagraph: (id, data) => api.put(`/typing/paragraphs/${id}`, data),

  deleteParagraph: (id) => api.delete(`/typing/paragraphs/${id}`),

  toggleParagraphStatus: (id) => api.patch(`/typing/paragraphs/${id}/toggle`),

  // Subscription management (Admin)
  grantSubscription: (email, note = '') =>
    api.post('/typing/subscriptions/grant', { email, note }),

  revokeSubscription: (email) =>
    api.post('/typing/subscriptions/revoke', { email }),

  getAllSubscriptions: () => api.get('/typing/subscriptions'),
};

export default api;